import React, { useState, useCallback, useEffect, useRef } from "react";
import Heading from "../../../../../common/element/Heading";
import BtnLight from "../../../../../common/element/Buttons/btnLight";
import Table from "../../../../../common/element/Table";
import Segment from "../../../../../common/element/Segment";
import Tag from "../../../../../common/element/Tag";
import SearchImg from "../../../../../assets/icons-svg/search-lg.svg";
import Badge from "../../../../../common/element/Badge";
import ClientInput from "../../../../../common/element/Input/clientInput";
import moment from "moment";
import useCallbackRef from "../../../../../common/element/hooks/useCallbackRef";
import Tooltip from "../../../../../common/element/Tooltip";
import { debounce } from "../../../../../common/snippet/Debouncing";
// import {
//   MarkTaskAsRead,
// } from "../../../../../actions/Admin";
import TotalClientsAndProviders from "../../../../adminPortal/pages/Client/DashboardAllClient/TotalClientsAndProviders";
import { MarkTaskAsRead } from "../../../../../actions/client-portal/MarkTaskAsRead";
import { UpdateTaskArchiveStatus } from "../../../../../actions/client-portal/UpdateTaskArchiveStatus";
import { GetAllDeshboardTasks } from "../../../../../actions/client-portal/GetAllDeshboardTasks";
import { useParams, Link } from "react-router-dom";
import Scrollbar from "../../../../../common/element/ScrollBar";
import { decryptId } from "../../../../../common/encryptDecrypt/encryptdecrypt";
import * as userActions from "../../../../../actions/index";
import { useNavigate } from "react-router-dom";
import InductionView from "../Inductions/Dialog/InductionView";
import { setBreadcrumbs } from "../../../../../redux/classes/breadcrumbsSlice";
import { useDispatch, useSelector } from "react-redux";
import { ResetEditInduction } from "../../../../../redux/classes/client-portal/EeditInduction";
import { InductuionDetailForm } from "../../../../../redux/classes/client-portal/inductionDetailsForm";
import { ResetInductionModuleData } from "../../../../../redux/classes/client-portal/inductionModuleDataSlice";
import { AddInductionModuleData } from "../../../../../redux/classes/client-portal/inductionModuleDataSlice";
import { GetCompanyInductionAndModulesbyId } from "../../../../../actions/client-portal/GetCompanyInductionAndModulesbyIdApi";
import useUnauthorizedHandler from "../../../../../common/snippet/useUnauthorizedHandler";
import Dialog from "../../../../../common/element/Dialog";
import { GetComplianceChecklist,GetAllComplianceChecklistNext30Days } from "../../../../../actions/client-portal/AllContactsApi";
import { DashboardClientCompanyInductions } from "../../../../../actions/client-portal/AllContactsApi";
import { GetClientDashboardDueInvoicesByDays } from "../../../../../actions/client-portal/invoices/GetClientDashboardDueInvoicesByDays";
import { GetClientProviderComplianceStatusCount } from "../../../../../actions/Admin-Client/AllSiteApi";
import { Doughnut } from "react-chartjs-2";
const Dashboard = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { Tr, Th, Td, THead, TBody } = Table;

  const [totalTastCount, setTotalTaskCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const scrollContainerRef = useRef(null);
  const [scrollThreshold, setScrollThreshold] = useState(23);
  const [limit, setLimit] = useState(30);
  const [searchTerm, setSearchTerm] = useState("");
  const [notificationList, setNotificationList] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [loading, setLoading] = useState(false);
  const [singleSegmentValue, setSingleSegmentValue] = useState(["Inbox"]);
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const [dialogIsOpen, setIsOpen] = useState(false);
  const [checkEditdata, SetcheckEditdata] = useState(true);
  const [inductionData, setInductionData] = useState("");
  const [DocData, setDocData] = useState("");
  const [contactTypeId, setContactTypeId] = useState("");
  const [invoiceData, SetInvoiceData] = useState([]);

  const [forceRender, setForceRender] = useState(false);
  const permissionDataUpdate = useSelector(
    (state) => state?.permissions?.permissionData
  );
  const Allfunction = useSelector((state) => state);
  const AllContactType = useSelector((state) => state?.AllContactTypes);
  const [clientFunctionId, setProviderfunctionId] = useState("")
  const AllFunctions = useSelector((state) => state.allFunctions);

  const [editBtnHide, setEditBtnHide] = useState(false);
  let permission_data;
  let trading_name;
  let organisation_id;
  let function_assignment_id;
  const permissionData = JSON.parse(localStorage?.getItem("permission_data"));
  const orgId = JSON.parse(localStorage.getItem("LoginUserData"));
  const [clientData, setClientData] = useState({
    compliant: 0,
    non_compliant: 0,
    total_provider: 0,
  });
  if (permissionData !== null) {
    permission_data = permissionData;
  }
  useEffect(() => {
    if (AllFunctions?.allFunction) {
      let functionType = AllFunctions?.allFunction.filter(
        (item) => item?.function_name === "client" // client function id 
      );
      setProviderfunctionId(functionType[0]?.function_id);
    }
  }, []);
  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          label: "Dashboard",
          url: "/client/dashboard",
          home: "/client/dashboard",
        },
      ])
    );
  }, []);
  useEffect(() => {
    if (permissionDataUpdate !== null) {
      localStorage.setItem(
        "permission_data",
        JSON.stringify(permissionDataUpdate)
      );
      setForceRender((prevForceRender) => !prevForceRender);
      const viewRoutes = {
        dashboard_view: "/client/dashboard",
        provider_view: "/client/provider",
        users_view: "/client/users",
        compliance_view: "/client/compliance",
        induction_view: "/client/inductions",
        sites_view: "/client/sites",
        messages_view: "/client/messages",
        contacts_view: "/client/contacts",
        notes_view: "/client/Notes",
        invoices_view: "/client/invoices",
        reporting_view: "/client/reports",
        support_view: "/client/support",
        settings_view: "/client/settings",
      };

      // Find the first view that is true and navigate to its route
      const route = Object.keys(viewRoutes).find(
        (view) => permissionDataUpdate[view]
      );

      // If a route is found, navigate to it, otherwise navigate to the "no access" page
      if (route) {
        navigate(viewRoutes[route]);
      } else {
        navigate("/client/noaccess");
      }
    }
  }, [permissionDataUpdate]);

  //   space bsdaagsedfgsdav
  //   space bsdaagsedfgsdav
  //   space bsdaagsedfgsdav
  const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
  if (storedData !== null) {
    organisation_id = storedData?.organisation_id;
    function_assignment_id = storedData?.function_assignment_id;
    trading_name = storedData?.trading_name ? storedData?.trading_name : "";
  }
  const userId = storedData?.userName?.user_id || storedData?.data?.user_id;
  const userRole = "client";

  const compliancePermission =
    permission_data?.compliance_view == true ? false : true;
  const inductionPermission =
    permission_data?.induction_view == true ? true : false;
  const providerPermission =
    permission_data?.provider_view == true ? false : true;
  const invoicesPermission =
    permission_data?.invoices_view == true ? false : true;

  const onSingleSelectionSegmentChange = useCallback(
    (val) => {
      setSingleSegmentValue(val);
    },
    [setSingleSegmentValue]
  );

  const today = moment().startOf("day");
  const yesterday = moment().subtract(1, "day").startOf("day");
  const startOfWeek = moment().startOf("week");
  const startOfMonth = moment().startOf("month");
  const startOfYear = moment().startOf("year");

  const groupedNotifications = notificationList?.reduce(
    (acc, notification) => {
      const createdDate = moment(notification?.created_date);

      if (createdDate.isSame(today, "d")) {
        acc.today.push(notification);
      } else if (createdDate.isSame(yesterday, "d")) {
        acc.yesterday.push(notification);
      } else if (createdDate.isSameOrAfter(startOfWeek)) {
        acc.thisWeek.push(notification);
      } else if (createdDate.isSameOrAfter(startOfMonth)) {
        acc.thisMonth.push(notification);
      } else if (createdDate.isSameOrAfter(startOfYear)) {
        acc.thisYear.push(notification);
      } else {
        acc.earlier.push(notification);
      }
      return acc;
    },
    {
      today: [],
      yesterday: [],
      thisWeek: [],
      thisMonth: [],
      thisYear: [],
      earlier: [],
    }
  );
  useEffect(() => {
    const handleScroll = () => {
      const scrollContainer = scrollContainerRef.current;
      if (
        scrollContainer &&
        scrollContainer.scrollTop >= scrollThreshold &&
        !isFetching &&
        notificationList?.length < totalCount
      ) {
        setLimit((prevLimit) => prevLimit + 10);
        setScrollThreshold((prevThreshold) => prevThreshold + 150);
      }
    };
    const scrollContainer = scrollContainerRef.current;
    scrollContainer?.addEventListener("scroll", handleScroll);

    return () => {
      scrollContainer?.removeEventListener("scroll", handleScroll);
    };
  }, [isFetching, scrollThreshold, totalCount, notificationList]);
  const GetTasksNotifications = useCallback(() => {
    // setIsFetching(true);
    const payload = {
      limit: limit,
      role_name: userRole,
      user_id: userId,
      is_archived: singleSegmentValue[0] == "Inbox" ? false : true,
      organisation: `org_${organisation_id}`,
      search: searchTerm,
    };
    dispatch(GetAllDeshboardTasks(payload)).then((res) => {
      // setIsFetching(false);
      if (res?.success === true) {
        const arrayData = res?.data.rows;
        setNotificationList(arrayData);
        setTotalTaskCount(res?.data?.unreadCount);
        setTotalCount(res?.data?.count);
      }
    });
  }, [dispatch, singleSegmentValue, searchTerm, limit]);
  useEffect(() => {
    GetTasksNotifications();
  }, [singleSegmentValue, searchTerm, limit]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value.trim());
  };
  const inputchangehandler = useCallbackRef(debounce(handleSearch), []);

  const archiveTask = (notify) => {
    const payload = {
      role_name: userRole,
      notification_id: notify.notification_id,
      is_archived: true,
      user_id: userId,
    };
    dispatch(UpdateTaskArchiveStatus(payload)).then((res) => {
      if (res?.success === true) {
        GetTasksNotifications();
      } else if (res?.status === 401) {
        handleUnauthorizedAccess();
      } else {
        // Handle other errors
      }
    });
  };

  const onMarkAsRead = (notifyId) => {
    const payload = {
      role_name: userRole,
      notification_id: notifyId,
      user_id: userId,
      task_read: true,
    };
    dispatch(MarkTaskAsRead(payload)).then((res) => {
      if (res?.success === true) {
        setTotalTaskCount(totalTastCount - 1); // Fixed typo: 'totalTastCount' -> 'totalTaskCount'
        setNotificationList((prevList) => {
          return prevList.map((item) => {
            if (item?.notification_id === notifyId) {
              return { ...item, task_read: true };
            }
            return item;
          });
        });
      } else if (res?.status === 401) {
        handleUnauthorizedAccess();
      } else {
        // Handle other errors
      }
    });
  };

  const GetAllComplianceChecklistOfClient = useCallback(async () => {
    try {
      const payload={client_org_id:organisation_id}
      const response = await dispatch(
        GetAllComplianceChecklistNext30Days(payload)
        // GetComplianceChecklist(
        //   organisation_id,
         
        // )
      );

      const { success, data, status } = response;
      if (success) {
        const { rows } = data;
        // setCountData(response?.data?.count);
        setDocData(rows);
        // setTotalPages(Math.ceil(response?.data?.count / filterlimit));
      } else if (status === 401) {
        handleUnauthorizedAccess();
      } else {
        console.error("Failed to fetch compliance checklist:", response);
        // Handle other types of errors or unsuccessful responses
      }
    } catch (error) {
      console.error("Failed to fetch compliance checklist:", error);
      // Handle unexpected errors
    }
  }, [dispatch, organisation_id]);

  useEffect(() => {
    GetAllComplianceChecklistOfClient();
  }, [GetAllComplianceChecklistOfClient, organisation_id]);

  const fetchDashboardClientsCompanyInd = useCallback(async () => {
    if (function_assignment_id) {
      try {
        const response = await dispatch(
          DashboardClientCompanyInductions(function_assignment_id)
        );
        if (response?.success) {
          const arrayData = response?.data;
          setInductionData(arrayData);
        } else if (response?.status === 401) {
          handleUnauthorizedAccess();
        } else {
          // Handle other errors
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  }, [dispatch]);

  useEffect(() => {
    fetchDashboardClientsCompanyInd();
  }, []);

  const openDialog = (company_induction_id) => {
    SetcheckEditdata(true);
    dispatch(ResetEditInduction());
    dispatch(ResetInductionModuleData());
    setEditBtnHide(true);
    dispatch(GetCompanyInductionAndModulesbyId(company_induction_id)).then(
      (response) => {
        if (response?.success) {
          dispatch(
            InductuionDetailForm({
              function_assignment_id: response?.data?.function_assignment_id,
              company_ind_name: response?.data?.company_ind_name,
              company_ind_desc: response?.data?.company_ind_desc,
              company_induction_id: response?.data?.company_induction_id,
              company_ind_status: response?.data?.company_ind_status,
              company_ind_valid_days: response?.data?.company_ind_valid_days,
              company_ind_publish_date:
                response?.data?.company_ind_publish_date,
            })
          );
          response?.data?.company_ind_modules.map((item) => {
            dispatch(AddInductionModuleData(item));
          });
        } else if (response?.status === 401) {
          handleUnauthorizedAccess();
        }
      }
    );
    setIsOpen(true);
  };
  const onDialogClose = (e) => {
    setIsOpen(false);
    dispatch(ResetInductionModuleData());
    dispatch(ResetEditInduction());
    SetcheckEditdata(false);
  };
  const closeViewInduction = () => {
    dispatch(ResetEditInduction());
    SetcheckEditdata(false);
    setIsOpen(false);
  };

  const handleEditinduction = (company_induction_id, e) => {
    if (e === "EditModule") {
      SetcheckEditdata(true);
      dispatch(ResetEditInduction());
      dispatch(ResetInductionModuleData());
      dispatch(GetCompanyInductionAndModulesbyId(company_induction_id)).then(
        (response) => {
          if (response?.success) {
            dispatch(
              InductuionDetailForm({
                function_assignment_id: response?.data?.function_assignment_id,
                company_ind_name: response?.data?.company_ind_name,
                company_ind_desc: response?.data?.company_ind_desc,
                company_induction_id: response?.data?.company_induction_id,
                company_ind_status: response?.data?.company_ind_status,
                company_ind_valid_days: response?.data?.company_ind_valid_days,
                company_ind_publish_date:
                  response?.data?.company_ind_publish_date,
              })
            );
            response?.data?.company_ind_modules.map((item) => {
              dispatch(AddInductionModuleData(item));
            });
          } else if (response?.status === 401) {
            handleUnauthorizedAccess();
          }
        }
      );
      setIsOpen(true);
      // dispatch(EditInduction(true));
      setIsOpen(false);
    } else {
      SetcheckEditdata(true);
      dispatch(ResetEditInduction());
      // dispatch(EditInduction(true));
      // SetcheckEditdata(false);
      setIsOpen(false);
    }
  };

  useEffect(() => {
    dispatch(
      GetClientDashboardDueInvoicesByDays({
        client_org_id: storedData?.organisation_id,
      })
    ).then((response) => {
      if (response.success) {
        SetInvoiceData(response.data);
      }
    });
  }, []);

  const fetchClientProviderComplianceStatusCount = useCallback(() => {
    if (orgId && clientFunctionId) {
      dispatch(
        GetClientProviderComplianceStatusCount({
          client_org_id: orgId?.organisation_id,
          function_id :clientFunctionId || ""
        })
      )
        .then((response) => {
          if (response.success) {
    
            setClientData({
              compliant: response?.data?.compliant || 0,
              non_compliant: response?.data?.non_compliant || 0,
            
            });
          } else if (response.status === 401) {
            handleUnauthorizedAccess();
          }
        })
        .catch((error) => {
          // Handle error here
          console.error("Error fetching client data: ", error);
        });
    }
  }, [dispatch, clientFunctionId, ]);

  useEffect(() => {
    fetchClientProviderComplianceStatusCount();
  }, [fetchClientProviderComplianceStatusCount, clientFunctionId]);

  const data = {
    labels: [
      `Compliant ${clientData?.compliant || 0}`,
      `Non-Compliant ${clientData["non_compliant"] || 0}`,
      `Invited ${clientData?.total_provider || 0}`,
    ],
    datasets: [
      {
        label: "Provider Status",
        data: [
          Number(clientData?.compliant || 0),
          Number(clientData["non_compliant"] || 0),
          Number(clientData?.total_provider || 0),
        ],
        backgroundColor: ["#86E5B2", "#FDA29B", "#d0d5dd"],
        hoverOffset: 4,
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        // display: true,
        position: "right",

        labels: {
          boxWidth: 10,
          padding: 20,
          borderWidth: 0.3,
          usePointStyle: true, // Add this line to make legend circles
        },
      },
    },
    cutout: "70%", // To make it a doughnut chart
  };

  // Custom plugin to draw text in the center
  const centerTextPlugin = {
    id: "centerText",
    beforeDraw: (chart) => {
      const {
        ctx,
        data,
        chartArea: { width, height },
      } = chart;
      ctx.save();

      // Only sum the first 2 values (Compliant + Non-Compliant, exclude Invited)
      const total = data.datasets[0].data
        .slice(0, 2) // Take first 2 elements only
        .reduce((acc, value) => acc + Number(value), 0);

      if (total === 0 && data.datasets[0].data.length <= 2) {
        // Handle "No Data" case (if Compliant + Non-Compliant = 0)
        ctx.font = "bold 16px Arial";
        ctx.fillStyle = "#6B7280";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText("No Data", width / 2, height / 2);
      } else {
        // Display total (Compliant + Non-Compliant only)
        ctx.font = "bold 20px Arial";
        ctx.fillStyle = "#1D2939";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(`${total}`, width / 2, height / 2 - 10);
        ctx.font = "13px Arial";
        ctx.fillText("Providers", width / 2, height / 2 + 10);
      }
      ctx.restore();
    },
  };

  return (
    <React.Fragment>
      <Heading className="mb-4">Dashboard</Heading>
      <div className="grid grid-container gap-8">
        <div className="flex gap-8 flex-col">
          <div className="bg-white py-5 rounded-xl dark-shadow">
            <div className="card-header flex justify-between border-b border-gray-200 pb-5 px-5 mb-3">
              <span className="text-gray-900 text-base font-semibold flex items-center">
                <span className="mr-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M6 15L8 17L12.5 12.5M8 8V5.2C8 4.0799 8 3.51984 8.21799 3.09202C8.40973 2.71569 8.71569 2.40973 9.09202 2.21799C9.51984 2 10.0799 2 11.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.0799 22 5.2V12.8C22 13.9201 22 14.4802 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.4802 16 19.9201 16 18.8 16H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                Tasks{" "}
                <Tag className="text-blue-800 bg-blue-100 ml-2">
                  {totalTastCount}
                </Tag>
              </span>
              {/* <BtnLight className="w-20">View All</BtnLight> */}
            </div>
            <div className="flex justify-between mb-3 px-4">
              <Segment
                className="docType-btn"
                value={singleSegmentValue[0] == "Inbox" ? "Inbox" : "Archive"}
                onChange={(val) => onSingleSelectionSegmentChange(val)}
              >
                <Segment.Item value="Inbox">Inbox</Segment.Item>
                <Segment.Item value="Archive">Archive</Segment.Item>
              </Segment>
              <div className="w-80 h-10">
                <div className="input-wrapper">
                  <div className="input-suffix-start left-3.5">
                    <img src={SearchImg} alt="" className="h-5" />
                  </div>
                  <ClientInput
                    type="text"
                    className="input  pl-10 w-80  input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border  text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    placeholder="Search"
                    inputchangehandler={inputchangehandler}
                    name={"search"}
                  />
                </div>
              </div>
            </div>
            <div
              ref={scrollContainerRef}
              className="notification-list-container overflow-y-auto max-h-[839px]"
            >
              <Table className="min-w-full whitespace-nowrap">
                <THead>
                  <Tr>
                    <Th className="pl-6 w-3xs	">Notification</Th>
                    <Th  className="w-1/4">Timestamp</Th>
                    <Th className="w-84">Company</Th>
                    {singleSegmentValue[0] == "Inbox" && (
                      <Th className="">Action</Th>
                    )}
                  </Tr>
                </THead>
                <tbody className={`overflow-y-auto notification-list `}>
                  {loading ? (
                    <tr>
                      <td colSpan="4" className="text-center p-4">
                        Loading...
                      </td>
                    </tr>
                  ) : notificationList.length === 0 ? (
                    <tr>
                      <td colSpan="4" className="text-center p-4">
                        No data available
                      </td>
                    </tr>
                  ) : (
                    <>
                      {groupedNotifications.today.length > 0 && (
                        <>
                          <tr>
                            <td
                              colSpan="4"
                              className="text-blue-700 font-bold px-6 py-2 mt-2"
                            >
                              Today
                            </td>
                          </tr>
                          {groupedNotifications.today.map((notif) => (
                            <React.Fragment key={notif.notification_id}>
                              <tr>

                                <td className="flex justify-between  px-6 hover:bg-blue-50">
                                  <Link
                                    className={`flex gap-2 ${notif?.task_read ? "" : "font-bold"}`}
                                    to="#"
                                    onClick={() =>
                                      !notif?.task_read && onMarkAsRead(notif.notification_id)
                                    }
                                  >
                                    {notif?.task_read === true ? (
                                      <div width="10" height="10"></div>
                                    ) : (
                                      <svg
                                        className="self-center"
                                        width="10"
                                        height="10"
                                        viewBox="0 0 10 10"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx="5" cy="5" r="5" fill="#5786CC" />
                                      </svg>
                                    )}
                                    <Tooltip title={notif.message}>
                                      <span className="text-gray-700 w-72 noti-newwrap">
                                        {notif.message}
                                      </span>
                                    </Tooltip>
                                  </Link>
                                </td>
                                <td className="px-4 py-1.5 w-3xs">
                                  <span >
                                    {moment(notif.created_date).format("HH:mm DD/MM/YY")}
                                  </span>
                                </td>
                                <td className="px-4 py-1.5">
                                  <Tooltip title={notif.trading_name}>
                                    <span className="w-32 noti-newwrap cursor-pointer">
                                      {notif?.trading_name ? notif.trading_name : "-"}
                                    </span>
                                  </Tooltip>
                                </td>
                                <td className="px-4 py-1.5">
                                  {singleSegmentValue[0] === "Inbox" && (
                                    <span
                                      className="text-blue-700 font-semibold cursor-pointer"
                                      onClick={() => archiveTask(notif)}
                                    >
                                      {notif?.action ? notif.action : "Archive"}
                                    </span>
                                  )}
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}


                        </>
                      )}
                      {groupedNotifications.yesterday.length > 0 && (
                        <>
                          <tr>
                            <td
                              colSpan="4"
                              className="text-blue-700 font-bold px-6 py-2 mt-2"
                            >
                              Yesterday
                            </td>
                          </tr>
                          {groupedNotifications.yesterday.map((notif) => (
                            <React.Fragment key={notif.notification_id}>
                              <tr>

                                <td className="flex justify-between  px-6 hover:bg-blue-50">
                                  <Link
                                    className={`flex gap-2 ${notif?.task_read ? "" : "font-bold"}`}
                                    to="#"
                                    onClick={() =>
                                      !notif?.task_read && onMarkAsRead(notif.notification_id)
                                    }
                                  >
                                    {notif?.task_read === true ? (
                                      <div width="10" height="10"></div>
                                    ) : (
                                      <svg
                                        className="self-center"
                                        width="10"
                                        height="10"
                                        viewBox="0 0 10 10"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx="5" cy="5" r="5" fill="#5786CC" />
                                      </svg>
                                    )}
                                    <Tooltip title={notif.message}>
                                      <span className="text-gray-700 w-72 noti-newwrap">
                                        {notif.message}
                                      </span>
                                    </Tooltip>
                                  </Link>
                                </td>
                                <td className="px-4 py-1.5">
                                  <span >
                                    {moment(notif.created_date).format("HH:mm DD/MM/YY")}
                                  </span>
                                </td>
                                <td className="px-4 py-1.5">
                                  <Tooltip title={notif.trading_name}>
                                    <span className="w-32 noti-newwrap cursor-pointer">
                                      {notif?.trading_name ? notif.trading_name : "-"}
                                    </span>
                                  </Tooltip>
                                </td>
                                <td className="px-4 py-1.5">
                                  {singleSegmentValue[0] === "Inbox" && (
                                    <span
                                      className="text-blue-700 font-semibold cursor-pointer"
                                      onClick={() => archiveTask(notif)}
                                    >
                                      {notif?.action ? notif.action : "Archive"}
                                    </span>
                                  )}
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}


                        </>
                      )}
                      {groupedNotifications.thisWeek.length > 0 && (
                        <>
                          <tr>
                            <td
                              colSpan="4"
                              className="text-blue-700 font-bold px-6 py-2 mt-2"
                            >
                              This week
                            </td>
                          </tr>
                          {groupedNotifications.thisWeek.map((notif) => (
                            <React.Fragment key={notif.notification_id}>
                              <tr>
                                <td className="flex justify-between py-1.5 px-6 hover:bg-blue-50">
                                  <Link
                                    className={`flex gap-2 ${notif?.task_read ? "" : "font-bold"}`}
                                    to="#"
                                    onClick={() =>
                                      !notif?.task_read && onMarkAsRead(notif.notification_id)
                                    }
                                  >
                                    {notif?.task_read === true ? (
                                      <div width="10" height="10"></div>
                                    ) : (
                                      <svg
                                        className="self-center"
                                        width="10"
                                        height="10"
                                        viewBox="0 0 10 10"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx="5" cy="5" r="5" fill="#5786CC" />
                                      </svg>
                                    )}
                                    <Tooltip title={notif.message}>
                                      <span className="text-gray-700 w-72 noti-newwrap">
                                        {notif.message}
                                      </span>
                                    </Tooltip>
                                  </Link>
                                </td>
                                <td className="px-4 py-1.5">
                                  <span >
                                    {moment(notif.created_date).format("HH:mm DD/MM/YY")}
                                  </span>
                                </td>
                                <td className="px-4 py-1.5">
                                  <Tooltip title={notif.trading_name}>
                                    <span className="w-32 noti-newwrap cursor-pointer">
                                      {notif?.trading_name ? notif.trading_name : "-"}
                                    </span>
                                  </Tooltip>
                                </td>
                                <td className="px-4 py-1.5">
                                  {singleSegmentValue[0] === "Inbox" && (
                                    <span
                                      className="text-blue-700 font-semibold cursor-pointer"
                                      onClick={() => archiveTask(notif)}
                                    >
                                      {notif?.action ? notif.action : "Archive"}
                                    </span>
                                  )}
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}


                        </>
                      )}
                      {groupedNotifications.thisMonth.length > 0 && (
                        <>
                          <tr>
                            <td
                              colSpan="4"
                              className="text-blue-700 font-bold px-6 py-2 mt-2"
                            >
                              This month
                            </td>
                          </tr>


                          {groupedNotifications.thisMonth.map((notif) => (
                            <React.Fragment key={notif.notification_id}>
                              <tr>

                                <td className="flex justify-between  px-6 hover:bg-blue-50">
                                  <Link
                                    className={`flex gap-2 ${notif?.task_read ? "" : "font-bold"}`}
                                    to="#"
                                    onClick={() =>
                                      !notif?.task_read && onMarkAsRead(notif.notification_id)
                                    }
                                  >
                                    {notif?.task_read === true ? (
                                      <div width="10" height="10"></div>
                                    ) : (
                                      <svg
                                        className="self-center"
                                        width="10"
                                        height="10"
                                        viewBox="0 0 10 10"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx="5" cy="5" r="5" fill="#5786CC" />
                                      </svg>
                                    )}
                                    <Tooltip title={notif.message}>
                                      <span className="text-gray-700 w-72 noti-newwrap">
                                        {notif.message}
                                      </span>
                                    </Tooltip>
                                  </Link>
                                </td>
                                <td className="px-4 py-1.5">
                                  <span >
                                    {moment(notif.created_date).format("HH:mm DD/MM/YY")}
                                  </span>
                                </td>
                                <td className="px-4 py-1.5">
                                  <Tooltip title={notif.trading_name}>
                                    <span className="w-32 noti-newwrap cursor-pointer">
                                      {notif?.trading_name ? notif.trading_name : "-"}
                                    </span>
                                  </Tooltip>
                                </td>
                                <td className="px-4 py-1.5">
                                  {singleSegmentValue[0] === "Inbox" && (
                                    <span
                                      className="text-blue-700 font-semibold cursor-pointer"
                                      onClick={() => archiveTask(notif)}
                                    >
                                      {notif?.action ? notif.action : "Archive"}
                                    </span>
                                  )}
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}


                        </>
                      )}
                      {/* --0--------------------------------------------- */}
                      {groupedNotifications.thisYear.length > 0 && (
                        <>
                          <tr>
                            <td
                              colSpan="4"
                              className="text-blue-700 font-bold px-6 py-2 mt-2"
                            >
                              This year
                            </td>
                          </tr>
                          {groupedNotifications.thisYear.map((notif) => (
                            <React.Fragment key={notif.notification_id}>
                              <tr>

                                <td className="flex justify-between  px-6 hover:bg-blue-50">
                                  <Link
                                    className={`flex gap-2 ${notif?.task_read ? "" : "font-bold"}`}
                                    to="#"
                                    onClick={() =>
                                      !notif?.task_read && onMarkAsRead(notif.notification_id)
                                    }
                                  >
                                    {notif?.task_read === true ? (
                                      <div width="10" height="10"></div>
                                    ) : (
                                      <svg
                                        className="self-center"
                                        width="10"
                                        height="10"
                                        viewBox="0 0 10 10"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx="5" cy="5" r="5" fill="#5786CC" />
                                      </svg>
                                    )}
                                    <Tooltip title={notif.message}>
                                      <span className="text-gray-700 w-72 noti-newwrap">
                                        {notif.message}
                                      </span>
                                    </Tooltip>
                                  </Link>
                                </td>
                                <td className="px-4 py-1.5">
                                  <span >
                                    {moment(notif.created_date).format("HH:mm DD/MM/YY")}
                                  </span>
                                </td>
                                <td className="px-4 py-1.5">
                                  <Tooltip title={notif.trading_name}>
                                    <span className="w-32 noti-newwrap cursor-pointer">
                                      {notif?.trading_name ? notif.trading_name : "-"}
                                    </span>
                                  </Tooltip>
                                </td>
                                <td className="px-4 py-1.5">
                                  {singleSegmentValue[0] === "Inbox" && (
                                    <span
                                      className="text-blue-700 font-semibold cursor-pointer"
                                      onClick={() => archiveTask(notif)}
                                    >
                                      {notif?.action ? notif.action : "Archive"}
                                    </span>
                                  )}
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}


                        </>
                      )}
                    </>
                  )}
                </tbody>
                {isFetching && (
                  <div className="flex justify-center py-4">
                    <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-blue-600"></div>
                  </div>
                )}
              </Table>
            </div>
          </div>
          <div className="bg-white py-5 border border-gray-200 rounded-xl dark-shadow">
            <div className="card-header flex justify-between border-b border-gray-200 pb-5 px-5 mb-3">
              <div className="flex items-center">
                <span className="mr-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M9.35156 14.6667C9.35156 15.9553 10.3962 17 11.6849 17H13.8516C15.2323 17 16.3516 15.8807 16.3516 14.5C16.3516 13.1193 15.2323 12 13.8516 12H11.8516C10.4709 12 9.35156 10.8807 9.35156 9.5C9.35156 8.11929 10.4709 7 11.8516 7H14.0182C15.3069 7 16.3516 8.04467 16.3516 9.33333M12.8516 5.5V7M12.8516 17V18.5M22.8516 12C22.8516 17.5228 18.3744 22 12.8516 22C7.32871 22 2.85156 17.5228 2.85156 12C2.85156 6.47715 7.32871 2 12.8516 2C18.3744 2 22.8516 6.47715 22.8516 12Z"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <p></p>
                <div className="flex flex-col">
                  <span className="text-gray-900 text-base font-semibold">
                    Invoices
                  </span>
                  <p className="text-gray-600">Due in the next 30 days </p>
                </div>
              </div>
              <BtnLight
                className="w-20"
                disabled={invoicesPermission}
                onClick={() => navigate("/client/invoices")}
              >
                View All
              </BtnLight>
            </div>

            <div className="max-h-[345px] overflow-y-auto cstm-scrollbar">
              <div>
                <div className="px-5">
                  <div className="overflow-hidden border rounded-lg border-gray-200">
                    <Table>
                      <TBody>
                        {invoiceData?.length > 0 &&
                          invoiceData?.length != undefined &&
                          invoiceData?.map((item, index) => {
                            let status;
                            if (item.xero_invoice_status === "AUTHORISED") {
                              const today = new Date();
                              today.setHours(0, 0, 0, 0); // Set time to 00:00:00
                              const invoiceSendDate = new Date(
                                item.invoice_send_date
                              );
                              invoiceSendDate.setHours(0, 0, 0, 0); // Set time to 00:00:00
                              const upcomingCreatedDate = new Date(
                                item.upcoming_created_date
                              );
                              upcomingCreatedDate.setHours(0, 0, 0, 0); // Set time to 00:00:00
                              const dueDate = new Date(item.due_date);
                              dueDate.setHours(0, 0, 0, 0); // Set time to 00:00:00
                              // Check if today's date is between the two dates

                              if (
                                item.upcoming_created_date &&
                                // today >= upcomingCreatedDate &&
                                today < invoiceSendDate
                              ) {
                                status = "UPCOMING";
                              } else if (
                                today >= invoiceSendDate &&
                                today <= dueDate
                              ) {
                                status = "DUE";
                              }
                            }
                            return (
                              <Tr>
                                <Td>{item?.xero_invoice_number}</Td>
                                <Td>
                                  {(status == "UPCOMING" ||
                                    status == "DUE") && (
                                      <Tag className="bg-warning-50 text-warning-700">
                                        <span>
                                          <svg
                                            width="12"
                                            height="12"
                                            viewBox="0 0 12 12"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <g clip-path="url(#clip0_18999_70113)">
                                              <path
                                                d="M11.35 5.75L10.3503 6.75L9.34998 5.75M10.4725 6.5C10.4907 6.33583 10.5 6.169 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C7.41363 10.5 8.67502 9.84817 9.5 8.82867M6 3.5V6L7.5 7"
                                                stroke="#F79009"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_18999_70113">
                                                <rect
                                                  width="12"
                                                  height="12"
                                                  fill="white"
                                                />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                        </span>{" "}
                                        {status}
                                      </Tag>
                                    )}
                                </Td>
                                <Td>
                                  {item?.invoice_send_date
                                    ? moment(item?.invoice_send_date).format(
                                      "DD/MM/YYYY"
                                    )
                                    : "-"}
                                </Td>
                              </Tr>
                            );
                          })}
                        {(invoiceData?.length == 0 ||
                          invoiceData?.length == undefined) && (
                            <Td colSpan="2" className="text-center p-4">
                              No upcoming invoices
                            </Td>
                          )}
                        {/* <Tr>
                          <Td>[Provider name]</Td>

                          <Td>
                            <Tag className="bg-warning-100 text-warning-700">
                              <span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="13"
                                  height="12"
                                  viewBox="0 0 13 12"
                                  fill="none"
                                >
                                  <g clip-path="url(#clip0_5799_40401)">
                                    <path
                                      d="M12.2015 5.75L11.2018 6.75L10.2015 5.75M11.3241 6.5C11.3422 6.33583 11.3516 6.169 11.3516 6C11.3516 3.51472 9.33684 1.5 6.85156 1.5C4.36628 1.5 2.35156 3.51472 2.35156 6C2.35156 8.48528 4.36628 10.5 6.85156 10.5C8.2652 10.5 9.52658 9.84817 10.3516 8.82867M6.85156 3.5V6L8.35156 7"
                                      stroke="#F79009"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_5799_40401">
                                      <rect
                                        width="12"
                                        height="12"
                                        fill="white"
                                        transform="translate(0.851562)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </span>
                              Upcoming
                            </Tag>
                          </Td>
                          <Td>DD/MM/YYYY</Td>
                        </Tr>
                        <Tr>
                          <Td>[Provider name]</Td>

                          <Td>
                            <Tag className="bg-warning-100 text-warning-700">
                              <span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="13"
                                  height="12"
                                  viewBox="0 0 13 12"
                                  fill="none"
                                >
                                  <g clip-path="url(#clip0_5799_40401)">
                                    <path
                                      d="M12.2015 5.75L11.2018 6.75L10.2015 5.75M11.3241 6.5C11.3422 6.33583 11.3516 6.169 11.3516 6C11.3516 3.51472 9.33684 1.5 6.85156 1.5C4.36628 1.5 2.35156 3.51472 2.35156 6C2.35156 8.48528 4.36628 10.5 6.85156 10.5C8.2652 10.5 9.52658 9.84817 10.3516 8.82867M6.85156 3.5V6L8.35156 7"
                                      stroke="#F79009"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_5799_40401">
                                      <rect
                                        width="12"
                                        height="12"
                                        fill="white"
                                        transform="translate(0.851562)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </span>
                              Upcoming
                            </Tag>
                          </Td>
                          <Td>DD/MM/YYYY</Td>
                        </Tr>
                        <Tr>
                          <Td>[Provider name]</Td>

                          <Td>
                            <Tag className="bg-warning-100 text-warning-700">
                              <span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="13"
                                  height="12"
                                  viewBox="0 0 13 12"
                                  fill="none"
                                >
                                  <g clip-path="url(#clip0_5799_40401)">
                                    <path
                                      d="M12.2015 5.75L11.2018 6.75L10.2015 5.75M11.3241 6.5C11.3422 6.33583 11.3516 6.169 11.3516 6C11.3516 3.51472 9.33684 1.5 6.85156 1.5C4.36628 1.5 2.35156 3.51472 2.35156 6C2.35156 8.48528 4.36628 10.5 6.85156 10.5C8.2652 10.5 9.52658 9.84817 10.3516 8.82867M6.85156 3.5V6L8.35156 7"
                                      stroke="#F79009"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_5799_40401">
                                      <rect
                                        width="12"
                                        height="12"
                                        fill="white"
                                        transform="translate(0.851562)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </span>
                              Upcoming
                            </Tag>
                          </Td>
                          <Td>DD/MM/YYYY</Td>
                        </Tr>
                        <Tr>
                          <Td>[Provider name]</Td>

                          <Td>
                            <Tag className="bg-error-100 text-error-700">
                              <span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="13"
                                  height="12"
                                  viewBox="0 0 13 12"
                                  fill="none"
                                >
                                  <g clip-path="url(#clip0_5799_40406)">
                                    <path
                                      d="M6.85156 4V6M6.85156 8H6.85656M1.85156 4.26137V7.73863C1.85156 7.86092 1.85156 7.92207 1.86538 7.97962C1.87763 8.03063 1.89783 8.07941 1.92524 8.12414C1.95616 8.1746 1.9994 8.21784 2.08588 8.30431L4.54725 10.7657C4.63372 10.8522 4.67696 10.8954 4.72742 10.9263C4.77216 10.9537 4.82093 10.9739 4.87195 10.9862C4.92949 11 4.99064 11 5.11293 11H8.59019C8.71249 11 8.77363 11 8.83118 10.9862C8.8822 10.9739 8.93097 10.9537 8.9757 10.9263C9.02616 10.8954 9.0694 10.8522 9.15588 10.7657L11.6172 8.30431C11.7037 8.21784 11.747 8.1746 11.7779 8.12414C11.8053 8.07941 11.8255 8.03063 11.8377 7.97962C11.8516 7.92207 11.8516 7.86092 11.8516 7.73863V4.26137C11.8516 4.13908 11.8516 4.07793 11.8377 4.02038C11.8255 3.96937 11.8053 3.92059 11.7779 3.87586C11.747 3.8254 11.7037 3.78216 11.6172 3.69569L9.15588 1.23431C9.0694 1.14784 9.02616 1.1046 8.9757 1.07368C8.93097 1.04627 8.8822 1.02606 8.83118 1.01382C8.77363 1 8.71249 1 8.59019 1H5.11293C4.99064 1 4.92949 1 4.87195 1.01382C4.82093 1.02606 4.77216 1.04627 4.72742 1.07368C4.67696 1.1046 4.63372 1.14784 4.54725 1.23431L2.08588 3.69569C1.9994 3.78216 1.95616 3.8254 1.92524 3.87586C1.89783 3.92059 1.87763 3.96937 1.86538 4.02038C1.85156 4.07793 1.85156 4.13908 1.85156 4.26137Z"
                                      stroke="#F04438"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_5799_40406">
                                      <rect
                                        width="12"
                                        height="12"
                                        fill="white"
                                        transform="translate(0.851562)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </span>
                              Overdue
                            </Tag>
                          </Td>
                          <Td>DD/MM/YYYY</Td>
                        </Tr>
                        <Tr>
                          <Td>[Provider name]</Td>

                          <Td>
                            <Tag className="bg-error-100 text-error-700">
                              <span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="13"
                                  height="12"
                                  viewBox="0 0 13 12"
                                  fill="none"
                                >
                                  <g clip-path="url(#clip0_5799_40406)">
                                    <path
                                      d="M6.85156 4V6M6.85156 8H6.85656M1.85156 4.26137V7.73863C1.85156 7.86092 1.85156 7.92207 1.86538 7.97962C1.87763 8.03063 1.89783 8.07941 1.92524 8.12414C1.95616 8.1746 1.9994 8.21784 2.08588 8.30431L4.54725 10.7657C4.63372 10.8522 4.67696 10.8954 4.72742 10.9263C4.77216 10.9537 4.82093 10.9739 4.87195 10.9862C4.92949 11 4.99064 11 5.11293 11H8.59019C8.71249 11 8.77363 11 8.83118 10.9862C8.8822 10.9739 8.93097 10.9537 8.9757 10.9263C9.02616 10.8954 9.0694 10.8522 9.15588 10.7657L11.6172 8.30431C11.7037 8.21784 11.747 8.1746 11.7779 8.12414C11.8053 8.07941 11.8255 8.03063 11.8377 7.97962C11.8516 7.92207 11.8516 7.86092 11.8516 7.73863V4.26137C11.8516 4.13908 11.8516 4.07793 11.8377 4.02038C11.8255 3.96937 11.8053 3.92059 11.7779 3.87586C11.747 3.8254 11.7037 3.78216 11.6172 3.69569L9.15588 1.23431C9.0694 1.14784 9.02616 1.1046 8.9757 1.07368C8.93097 1.04627 8.8822 1.02606 8.83118 1.01382C8.77363 1 8.71249 1 8.59019 1H5.11293C4.99064 1 4.92949 1 4.87195 1.01382C4.82093 1.02606 4.77216 1.04627 4.72742 1.07368C4.67696 1.1046 4.63372 1.14784 4.54725 1.23431L2.08588 3.69569C1.9994 3.78216 1.95616 3.8254 1.92524 3.87586C1.89783 3.92059 1.87763 3.96937 1.86538 4.02038C1.85156 4.07793 1.85156 4.13908 1.85156 4.26137Z"
                                      stroke="#F04438"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_5799_40406">
                                      <rect
                                        width="12"
                                        height="12"
                                        fill="white"
                                        transform="translate(0.851562)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </span>
                              Overdue
                            </Tag>
                          </Td>
                          <Td>DD/MM/YYYY</Td>
                        </Tr>
                        <Tr>
                          <Td>[Provider name]</Td>

                          <Td>
                            <Tag className="bg-error-100 text-error-700">
                              <span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="13"
                                  height="12"
                                  viewBox="0 0 13 12"
                                  fill="none"
                                >
                                  <g clip-path="url(#clip0_5799_40406)">
                                    <path
                                      d="M6.85156 4V6M6.85156 8H6.85656M1.85156 4.26137V7.73863C1.85156 7.86092 1.85156 7.92207 1.86538 7.97962C1.87763 8.03063 1.89783 8.07941 1.92524 8.12414C1.95616 8.1746 1.9994 8.21784 2.08588 8.30431L4.54725 10.7657C4.63372 10.8522 4.67696 10.8954 4.72742 10.9263C4.77216 10.9537 4.82093 10.9739 4.87195 10.9862C4.92949 11 4.99064 11 5.11293 11H8.59019C8.71249 11 8.77363 11 8.83118 10.9862C8.8822 10.9739 8.93097 10.9537 8.9757 10.9263C9.02616 10.8954 9.0694 10.8522 9.15588 10.7657L11.6172 8.30431C11.7037 8.21784 11.747 8.1746 11.7779 8.12414C11.8053 8.07941 11.8255 8.03063 11.8377 7.97962C11.8516 7.92207 11.8516 7.86092 11.8516 7.73863V4.26137C11.8516 4.13908 11.8516 4.07793 11.8377 4.02038C11.8255 3.96937 11.8053 3.92059 11.7779 3.87586C11.747 3.8254 11.7037 3.78216 11.6172 3.69569L9.15588 1.23431C9.0694 1.14784 9.02616 1.1046 8.9757 1.07368C8.93097 1.04627 8.8822 1.02606 8.83118 1.01382C8.77363 1 8.71249 1 8.59019 1H5.11293C4.99064 1 4.92949 1 4.87195 1.01382C4.82093 1.02606 4.77216 1.04627 4.72742 1.07368C4.67696 1.1046 4.63372 1.14784 4.54725 1.23431L2.08588 3.69569C1.9994 3.78216 1.95616 3.8254 1.92524 3.87586C1.89783 3.92059 1.87763 3.96937 1.86538 4.02038C1.85156 4.07793 1.85156 4.13908 1.85156 4.26137Z"
                                      stroke="#F04438"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_5799_40406">
                                      <rect
                                        width="12"
                                        height="12"
                                        fill="white"
                                        transform="translate(0.851562)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </span>
                              Overdue
                            </Tag>
                          </Td>
                          <Td>DD/MM/YYYY</Td>
                        </Tr>
                        <Tr>
                          <Td>[Provider name]</Td>

                          <Td>
                            <Tag className="bg-error-100 text-error-700">
                              <span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="13"
                                  height="12"
                                  viewBox="0 0 13 12"
                                  fill="none"
                                >
                                  <g clip-path="url(#clip0_5799_40406)">
                                    <path
                                      d="M6.85156 4V6M6.85156 8H6.85656M1.85156 4.26137V7.73863C1.85156 7.86092 1.85156 7.92207 1.86538 7.97962C1.87763 8.03063 1.89783 8.07941 1.92524 8.12414C1.95616 8.1746 1.9994 8.21784 2.08588 8.30431L4.54725 10.7657C4.63372 10.8522 4.67696 10.8954 4.72742 10.9263C4.77216 10.9537 4.82093 10.9739 4.87195 10.9862C4.92949 11 4.99064 11 5.11293 11H8.59019C8.71249 11 8.77363 11 8.83118 10.9862C8.8822 10.9739 8.93097 10.9537 8.9757 10.9263C9.02616 10.8954 9.0694 10.8522 9.15588 10.7657L11.6172 8.30431C11.7037 8.21784 11.747 8.1746 11.7779 8.12414C11.8053 8.07941 11.8255 8.03063 11.8377 7.97962C11.8516 7.92207 11.8516 7.86092 11.8516 7.73863V4.26137C11.8516 4.13908 11.8516 4.07793 11.8377 4.02038C11.8255 3.96937 11.8053 3.92059 11.7779 3.87586C11.747 3.8254 11.7037 3.78216 11.6172 3.69569L9.15588 1.23431C9.0694 1.14784 9.02616 1.1046 8.9757 1.07368C8.93097 1.04627 8.8822 1.02606 8.83118 1.01382C8.77363 1 8.71249 1 8.59019 1H5.11293C4.99064 1 4.92949 1 4.87195 1.01382C4.82093 1.02606 4.77216 1.04627 4.72742 1.07368C4.67696 1.1046 4.63372 1.14784 4.54725 1.23431L2.08588 3.69569C1.9994 3.78216 1.95616 3.8254 1.92524 3.87586C1.89783 3.92059 1.87763 3.96937 1.86538 4.02038C1.85156 4.07793 1.85156 4.13908 1.85156 4.26137Z"
                                      stroke="#F04438"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_5799_40406">
                                      <rect
                                        width="12"
                                        height="12"
                                        fill="white"
                                        transform="translate(0.851562)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </span>
                              Overdue
                            </Tag>
                          </Td>
                          <Td>DD/MM/YYYY</Td>
                        </Tr> */}
                      </TBody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex gap-8 flex-col">
         
                  <TotalClientsAndProviders chartData={clientData} title={"Providers"} 
                   redirectPath={"/client/provider"}  setDefaultTab={false}
                   providerPermission={providerPermission} />

          {compliancePermission == false && (
            <div className="py-5 border border-gray-200 rounded-xl dark-shadow">
              <div className="px-5">
                <div className="card-header flex justify-between border-b border-gray-200 pb-5 mb-3">
                  <div className="flex items-center">
                    <span className="mr-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M9 16L11 18L15.5 13.5M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z"
                          stroke="black"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    <p></p>
                    <div className="flex flex-col">
                      <span className="text-gray-900 text-base font-semibold">
                        Compliance Checklist{" "}
                      </span>
                      <p className="text-gray-600">
                        {/* Due for renewal in the next {remainingDays} days{" "} */}
                        Due for renewal in the next 30 days
                      </p>
                    </div>
                  </div>
                  {/* <Link to=></Link> */}
                  <BtnLight
                    disabled={compliancePermission}
                    className="w-20 h-9 cursor-pointer"
                    onClick={() => navigate("/client/compliance")}
                  >
                    <span className="cursor-pointer">View All</span>{" "}
                  </BtnLight>
                </div>
              </div>

              <div className="max-h-[345px] overflow-y-auto cstm-scrollbar">
                <div>
                  <div className="px-5">
                    <div className="overflow-hidden border rounded-lg border-gray-200">
                      <Table>
                        <TBody>
                          {DocData &&
                            DocData.map((item) => (
                              <Tr key={item?.compliance_doc_id}>
                                <Td>
                                  {item?.checklist_name}
                                  <span className="block text-gray-600">
                                    {item?.document_type}
                                  </span>
                                </Td>
                                <Td>
                                  {moment(item?.checklist_renewal_date).format(
                                    "DD/MM/YYYY"
                                  )}
                                </Td>
                              </Tr>
                            ))}
                          {(DocData?.length == 0 ||
                            DocData?.length == undefined) && (
                              <Td className="text-center p-4 block">
                                No data available
                              </Td>
                            )}
                        </TBody>
                      </Table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {inductionPermission == true && (
            <div className="bg-white border border-gray-200 rounded-xl dark-shadow">
              <div className="p-5">
                <div className="card-header flex justify-between border-b border-gray-200 pb-5 mb-3">
                  <div className="flex items-center ">
                    <span className="mr-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12 21L11.8999 20.8499C11.2053 19.808 10.858 19.287 10.3991 18.9098C9.99286 18.5759 9.52476 18.3254 9.02161 18.1726C8.45325 18 7.82711 18 6.57482 18H5.2C4.07989 18 3.51984 18 3.09202 17.782C2.71569 17.5903 2.40973 17.2843 2.21799 16.908C2 16.4802 2 15.9201 2 14.8V6.2C2 5.07989 2 4.51984 2.21799 4.09202C2.40973 3.71569 2.71569 3.40973 3.09202 3.21799C3.51984 3 4.07989 3 5.2 3H5.6C7.84021 3 8.96031 3 9.81596 3.43597C10.5686 3.81947 11.1805 4.43139 11.564 5.18404C12 6.03968 12 7.15979 12 9.4M12 21V9.4M12 21L12.1001 20.8499C12.7947 19.808 13.142 19.287 13.6009 18.9098C14.0071 18.5759 14.4752 18.3254 14.9784 18.1726C15.5467 18 16.1729 18 17.4252 18H18.8C19.9201 18 20.4802 18 20.908 17.782C21.2843 17.5903 21.5903 17.2843 21.782 16.908C22 16.4802 22 15.9201 22 14.8V6.2C22 5.07989 22 4.51984 21.782 4.09202C21.5903 3.71569 21.2843 3.40973 20.908 3.21799C20.4802 3 19.9201 3 18.8 3H18.4C16.1598 3 15.0397 3 14.184 3.43597C13.4314 3.81947 12.8195 4.43139 12.436 5.18404C12 6.03968 12 7.15979 12 9.4"
                          stroke="black"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    <div className="flex flex-col">
                      <span className="text-gray-900 text-base font-semibold">
                        Inductions
                      </span>
                      <p className="text-gray-600">
                        Due for activation or renewal{" "}
                      </p>
                    </div>
                  </div>
                  <BtnLight
                    disabled={inductionPermission == true ? false : true}
                    className="w-20 h-9"
                    onClick={() => navigate("/client/inductions")}
                  >
                    View All
                  </BtnLight>
                </div>
              </div>
              <div className="max-h-[345px] overflow-y-auto cstm-scrollbar">
                <div>
                  <div className="px-5 pb-5">
                    <div className="overflow-hidden border rounded-lg border-gray-200">
                      <Table>
                        <TBody>
                          {inductionData &&
                            inductionData.map((item) => (
                              <Tr
                                className={`${inductionPermission === true
                                  ? "cursor-pointer"
                                  : ""
                                  }`}
                                onClick={() => {
                                  inductionPermission == true &&
                                    openDialog(item?.company_induction_id);
                                }}
                                key={item?.company_induction_id}
                              >
                                <Td>
                                  {item?.company_ind_name
                                    ? item?.company_ind_name
                                    : "-"}
                                  <span className="block text-gray-600">
                                    {trading_name ? trading_name : "-"}
                                  </span>
                                </Td>
                                <Td>
                                  {item?.company_ind_publish_date
                                    ? item?.company_ind_publish_date
                                    : "-"}
                                </Td>
                                <Td
                                  className={`${inductionPermission === true
                                    ? "cursor-pointer"
                                    : ""
                                    }`}
                                  onClick={() => {
                                    inductionPermission == true &&
                                      openDialog(item?.company_induction_id);
                                  }}
                                >
                                  <Tag className="bg-blue-50 text-blue-800">
                                    Draft
                                  </Tag>
                                </Td>
                              </Tr>
                            ))}
                          {(inductionData?.length == 0 ||
                            inductionData?.length == undefined) && (
                              <Td className="text-center p-4 block">
                                No data available
                              </Td>
                            )}
                        </TBody>
                      </Table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* {checkEditdata && ( */}
      <Dialog
        isOpen={dialogIsOpen}
        onClose={onDialogClose}
        onRequestClose={onDialogClose}
        bodyOpenClassName="overflow-hidden"
        className="lg-dialog"
      >
        <div className="flex border-b pb-5 px-6 pt-6 items-center">
          <span className="h-12 w-12 border rounded-lg border-gray-200 flex items-center justify-center shadow-sm mr-4">
            <img src="/assets/icons-svg/file-check.svg" alt="" />
          </span>
          <div>
            <h5 className="mb-0 text-gray-900 text-base font-semibold">
              {Allfunction.inductionDetailData.company_ind_name}
            </h5>
          </div>
        </div>
        <InductionView
          inductionPermission={inductionPermission}
          closeViewInductionModule={closeViewInduction}
          handleEditinductionModule={handleEditinduction}
          editBtnHide={editBtnHide}
          setEditBtnHide={setEditBtnHide}
        />
      </Dialog>
      {/* )} */}
    </React.Fragment>
  );
};

export default Dashboard;
